{
  "title": "Mordenkainen's Sword",
  "source": "Player's Handbook",
  "levelAndSchool": "7th-level evocation",
  "level": 7,
  "castingTime": "1 action",
  "range": "60 feet",
  "components": "V, S, M (a miniature platinum sword with a grip and pommel of copper and zinc, worth 250 gp)",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "You create a sword-shaped plane of force that hovers within range. It lasts for the duration.",
    "When the sword appears, you make a melee spell attack against a target of your choice within 5 feet of the sword. On a hit. the target takes 3d10 force damage. Until the spell ends, you can use a bonus action on each of your turns to move the sword up to 20 feet to a spot you can see and repeat this attack against the same target or a different one."
  ],
  "spellLists": ["bard", "wizard"]
}
